import React from "react";
import Container from "../Common/Container";
import ColumnContainer from "../Common/ColumnContainer";
import RowContainer from "../Common/RowContainer";
import Particles from "../Common/ParticleDesign";
import { removeInlineColors } from "../../utils/htmlColorUtils";
import "../../stylesheets/common.css";
import '../../utils/stringExtention';

interface Conjugation {
  value: string;
  translation: string;
}

interface Data {
  id: number;
  flashCardContentComponentId: number;
  particleType: string;
  particleValue: string;
  conjugation: Conjugation[];
  lightTheme: string;
}

interface ConjugationComponentProps {
  data: Data;
  isBretzel?: boolean;
  onClick?: () => void;
}

// Static conjugation types
const conjugationTypes = ["ich", "du", "er/sie/es", "wir", "ihr", "sie/Sie"];

/**
 * Flutter logic:
 *   lightTheme == "Light" → bg #110929, text white
 *   else (dark)           → bg transparent, text #16162F
 */
const ConjugationComponent: React.FC<ConjugationComponentProps> = ({
  data,
  isBretzel = false,
  onClick,
}) => {
  const isLight = data?.lightTheme === "Light";
  const bgColor = isLight ? "#110929" : "transparent";
  const textColor = isLight ? "#FFFFFF" : "#16162F";
  const subTextColor = isLight ? "rgba(255,255,255,0.6)" : "rgba(22,22,47,0.6)";

  return (
    <Container
      bgColor={bgColor}
      color={textColor}
      width="100%"
      borderRadius="24px"
      padding={isBretzel ? "12px 18px" : "12px 24px"}
      cursor="pointer"
      onClick={onClick}
    >
      <ColumnContainer>
        <RowContainer alignItem="center" justifyContent="center">
          <Particles
            text={[data?.particleValue ?? "", ""]}
            type={[data?.particleType ?? "", ""]}
            textColor={textColor}
          />
        </RowContainer>
        <ColumnContainer width="100%" gap="0">
          {data?.conjugation && data?.conjugation.length
            ? conjugationTypes.slice(0, 3).map((type, index) => (
              <RowContainer
                key={index}
                justifyContent="space-between"
                className="block-text-component"
              >
                <ColumnContainer gap="0px" width="100%" alignItem="flex-start" flex="1">
                  <RowContainer gap="6px" className="block-text-component">
                    <strong>
                      <div style={{ color: textColor }}>{type}</div>
                    </strong>
                    <div
                      style={{ color: textColor }}
                      dangerouslySetInnerHTML={{
                        __html: removeInlineColors((data?.conjugation[index]?.value || "").cleanUpString()),
                      }}
                    />
                  </RowContainer>
                  <div
                    style={{ color: subTextColor }}
                    dangerouslySetInnerHTML={{
                      __html: removeInlineColors((data?.conjugation[index]?.translation || "").cleanUpString()),
                    }}
                    className="conjugation-component"
                  />
                </ColumnContainer>
                <ColumnContainer gap="0px" width="100%" alignItem="flex-end" justifyContent="flex-end" flex="1">
                  <RowContainer gap="6px" alignItem="flex-end" justifyContent="flex-end" className="block-text-component">
                    <strong>
                      <div style={{ color: textColor }}>
                        {conjugationTypes[index + 3] || ""}
                      </div>
                    </strong>
                    <div
                      style={{ color: textColor }}
                      dangerouslySetInnerHTML={{
                        __html: removeInlineColors((data?.conjugation[index + 3]?.value || "").cleanUpString()),
                      }}
                    />
                  </RowContainer>
                  <div
                    style={{ color: subTextColor }}
                    dangerouslySetInnerHTML={{
                      __html: removeInlineColors((data?.conjugation[index + 3]?.translation || "").cleanUpString()),
                    }}
                    className="conjugation-component"
                  />
                </ColumnContainer>
              </RowContainer>
            ))
            : ""}
        </ColumnContainer>
      </ColumnContainer>
    </Container>
  );
};

export default ConjugationComponent;
